/**
 * Kiosk mode — when a visitor lands on a shareable store link `/s/:username`,
 * the entire app is locked to that one storefront. Global chrome is hidden,
 * internal links rewrite to stay inside `/s/:username/*`, and any escape
 * attempt bounces them to the pre-register landing page `/`.
 */
import { createContext, useContext } from 'react';

export interface KioskContextValue {
  isKiosk: boolean;
  /** The store owner's @username extracted from the route. */
  ownerUsername: string;
}

const KioskContext = createContext<KioskContextValue>({
  isKiosk: false,
  ownerUsername: '',
});

export function KioskProvider({
  ownerUsername,
  children,
}: {
  ownerUsername: string;
  children: React.ReactNode;
}) {
  return (
    <KioskContext.Provider value={{ isKiosk: true, ownerUsername }}>
      {children}
    </KioskContext.Provider>
  );
}

export function useKiosk() {
  return useContext(KioskContext);
}
